import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency} from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import { getSalesPeopleDropDown, getCustomerDropDown } from './LargeProjectUtils'
import Select from 'react-select';
import LargeProjectsNav from './LargeProjectsNav'
import ViewLargeProjects from './ViewLargeProjects'
import {getCustomerList, getSalesPeople} from './ApiUtils'

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class EnterLargeProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            salesPeople: '',
            salesPeopleChoices: [],
            customerChoices: [],
            customers: '',
            loading: false,
            totalPayment:'',
            projectName:'',
            customerId:'',
            salesPersonId:'', 
            totalPayment:0
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                
                
                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    
                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    //this.getApiDetails();
                    getCustomerList(this.loadCustomerList);
                    getSalesPeople(this.loadSalesPeople);
                   
                }
            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
       // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    loadCustomerList = (customers) => {
        console.log("gtc14 ++++++++:loadCustomerList");
       // console.log("gtc15:"+customers);
        if(customers && customers.length > 0){
            console.log("gtc15 customer dropdown...")
            this.setState({
                customerChoices: getCustomerDropDown(customers)
            })
        }else{
            alert("unable to load customers")
        }
    }

    loadSalesPeople = (salesPeople) => {
        console.log("gts1 ++++++++:loadSalesPeopleDropdown");
        //console.log("gtc15:"+JSON.stringify(salesPeople,null,3));
        if(salesPeople && salesPeople.length > 0){
            console.log("gtc15 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        }else{
            alert("unable to load customers")
        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    getProjectList = () => {
        console.log("gpx1 ++++++++:getProjectList");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getProjectList', {
            apiKey: "PrintB@da7",
        })
            .then((response) => {
                this.setState({ loading: false })
             //   console.log("gpx12 results:"+JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    console.log("true.. adding customer");
                    this.setState({
                        projects: response.data.projects
                    })
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    getApiDetails = () => {
        console.log("++++++++:getApiDetails");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getApiDetails', {
            apiKey: "PrintB@da7",
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. adding customer");

                    // SET SALES PEOPLE DROP DOWN
                    if (response.data.salesPeople) {
                        this.setState({
                            salesPeopleChoices: getSalesPeopleDropDown(response.data.salesPeople)
                        })
                    }

                    // SET CUSTOMER DROP DOWN
                    if (response.data.customers) {
                        this.setState({
                            customerChoices: getCustomerDropDown(response.data.customers)
                        })
                    }

                    // this.setState({
                    //     customers: response.data.customers,
                    //     salesPeople: response.data.salesPeople
                    // })
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });

    }

    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    sendProjectDetails = () => {
        console.log("++++++++:sendCustomer");
        console.log(this.state.projectName)
        console.log(this.state.customerId)
        console.log(this.state.salesPersonId)

        if (this.state.projectName == '') {
            alert("No projectName Name")
        } else if (this.state.customerId == '') {
            alert("No Customer Selected")
        } else if (this.state.salesPersonId == '') {
            alert("No salesPerson selected")
        } else if (this.state.contactPerson1 == '') {
            alert("No Constact Person")
        } else {
            console.log("sending data..");

            this.setState({ loading: true })

            let temp  = {
                apiKey: "PrintB@da7",
                projectName: this.state.projectName,
                customerId: this.state.customerId,
                salesPersonId: this.state.salesPersonId,
                enteredBy: this.state.user.email,
                totalPayment: this.state.totalPayment,
            }

            console.log(JSON.stringify(temp,null,3))

            axios.post(pythonApiIp + 'addNewProject', {
                apiKey: "PrintB@da7",
                projectName: this.state.projectName,
                customerId: this.state.customerId,
                salesPersonId: this.state.salesPersonId,
                enteredBy: this.state.user.email,
                totalPayment: this.state.totalPayment,
                
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");

                        
                        if(response.data.project){
                            alert(response.data.message);
                            console.log("push to:"+"/dashboard/viewLargeProject/" + response.data.project.idlargeprojects);
                            history.push("/dashboard/viewLargeProject/" + response.data.project.idlargeprojects);
                        }else{
                            alert("unable to create project:"+response.data.message);
                        }
                       
                    } else {
                        console.log("FAILED");
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    
    render() {

        const salesPeopleDropDown = this.state.salesPeopleChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.salesPersonId}
                options={this.state.salesPeopleChoices}
                onChange={this.handleDropDownChanges}
                searchable={true}
                clearable={false}
            />
            : ''

        const customerDropDown = this.state.customerChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.customerId}
                options={this.state.customerChoices}
                onChange={this.handleDropDownChanges}
                searchable={true}
                clearable={true}
            />
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

<LargeProjectsNav />

                <h1>ENTER NEW LARGE PROJECT</h1>


                <Form size='large' onSubmit={this.sendProjectDetails}>
                    <Segment stacked>
                        <label>Enter Project Name</label>
                        <Form.Input
                            fluid
                            icon='blind'
                            iconPosition='left'
                            placeholder='Project Name'
                            type='text'
                            name="projectName"
                            value={this.state.projectName}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Order Amount (If You Know It)  </label><br/>
                        <label>{toCurrency(this.state.totalPayment)}</label>
                        <Form.Input
                            fluid
                            icon='phone'
                            iconPosition='left'
                            placeholder='Total Order Amount'
                            type='number'
                            name="totalPayment"
                            value={this.state.totalPayment}
                            onChange={this.handleTextInputChange}
                        />
                        <label>Select Customer Name</label>
                        {customerDropDown}
                        <br/>
                        <label>Select Sales Person</label>
                        {salesPeopleDropDown}

                        <Button>SEND</Button>
                    </Segment>

                </Form>
                <ViewLargeProjects />
            </div>
        );
    }
}

export default EnterLargeProject;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/EnterLargeProject.js